/**
 * The kind of a workflow node. Mirrors Osstre.Domain WorkflowNodeType.
 */
export enum WorkflowNodeType {
  /** Mechanism for entering the workflow */
  Trigger = 'trigger',
  /** An action to perform (e.g. send email, call webhook) */
  Action = 'action',
  /** Evaluates a condition / waits, to control flow */
  Rule = 'rule',
  /** Terminates the workflow path */
  Terminator = 'terminator'
}
